import { applicationsAttributesIDs } from 'app/sm/team_viewing_preference/applications-attributes.constants'
import { covertBoolStringToBool } from 'app/utils/strings/helpers'
import { isSAAutoRentalReferenceSettingEnabled } from 'config/features'

type ApplicationAttributes = Record<string, unknown>

export const parseSAAutoRentalReferenceSetting = (
  application: ApplicationAttributes = {},
  isPaidPlan = false,
): boolean => {
  if (!isSAAutoRentalReferenceSettingEnabled(isPaidPlan)) {
    return false
  }

  const value =
    application[applicationsAttributesIDs.saAutoRentalReferenceEnabled]
  return covertBoolStringToBool(value)
}

interface BuildSAAutoRentalReferenceSettingPayloadArgs {
  isPaidPlan: boolean
  enabled: boolean
}

export const buildSAAutoRentalReferenceSettingPayload = ({
  isPaidPlan,
  enabled,
}: BuildSAAutoRentalReferenceSettingPayloadArgs): Record<string, string> => {
  if (!isSAAutoRentalReferenceSettingEnabled(isPaidPlan)) {
    return {}
  }

  return {
    [applicationsAttributesIDs.saAutoRentalReferenceEnabled]:
      enabled.toString(),
  }
}
